import { Chip, type ChipProps } from '@mui/material';
import {
  refundStatusColorMap,
  refundStatusMap,
} from '@/constants/subsidy/status';
import type { RefundStatus } from '@/models/subsidy/status';

interface StatusChipProps {
  status: RefundStatus;
}

export const StatusChip = ({ status }: StatusChipProps) => {
  const color =
    (refundStatusColorMap[status] as ChipProps['color']) || 'default';
  return (
    <Chip
      label={refundStatusMap[status] ?? 'Informação não disponível'}
      color={color}
    />
  );
};
